module.exports = __webpack_public_path__ + "static/media/error-page.d7c00789.svg";